import { getImageUrl } from "../services/recipeServices";

const loadImageStore = () => {
  try {
    const data = localStorage.getItem("imageStore") ?? "{}";
    return JSON.parse(data);
  } catch (error) {
    return {}
  }
}
const saveImageStore = (store) => localStorage.setItem("imageStore", JSON.stringify(store));
const imageStore = loadImageStore();

export const getImage = async (imagePath) => {
  if (!imageStore[imagePath]) {
    const imageUrl = await getImageUrl(imagePath);
    imageStore[imagePath] = imageUrl;
    saveImageStore(imageStore)
  }
  return imageStore[imagePath];
};